import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";

export type AddCourseDTO = {
    name:string;
    description:string;
    googleForm:string;
    InstructorId:string | null;
    img_url:string;
    startDate:string;
    isLive:boolean;
    num_hours:string;
    actualPrice_egp:string;
    actualPrice_usd:string;
    preview_video:string;
    isTrending:boolean;
    isAvailable:boolean;

};

type CourseResponse  = AddCourseDTO & {
    id:string;
    createdAt:string;
    updatedAt:string;
} & ApiError;

export const AddNewOfflineCourse = (data: AddCourseDTO): Promise<CourseResponse> => {
    return axios.post("/offline-course/create", data)
        .then(response => response.data as CourseResponse);
};